<template>

<core-modal v-on:close="onClose" type="confirm">

	<template v-slot:head>

		Delete list

	</template>

	<template v-slot:default>

		<p>Are you sure you wish to delete this list and all editions?</p>

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onConfirmClick" :loading="is.loading">Yes</core-button>
		<core-button theme="plain" v-on:click.native="onClose">No</core-button>

	</template>

</core-modal>

</template>

<script>

export default {

	data: function() {

		return {

			is: {
				loading: false
			}

		}

	},

	methods: {

		onConfirmClick: function() {

			this.is.loading = true

			this.$store.dispatch('api/list/delete', {
				
			}).then(function() {

				this.$routerPush({
					name: 'Lists'
				})

				this.$emit('close')

			}.bind(this), function() {

				this.is.loading = false

			}.bind(this)) 

		},

		onClose: function() {

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

</style>